import { Fragment } from "react";
import Card from "../UI/Card";
import classes from "./Photos.module.css";
import MaterialsContext from "../../store/materials-context";
import { useContext, useState } from "react";
import Modal from "../UI/Modal";
import filesToDownload from "../../assets/materials/christmas.zip";
import croatia_pro_act from "../../assets/croatiaArticle/croatia_proj_activities.zip";
import gerVideoToDownload from "../../assets/materials/germany.MOV.zip";
import galleryHelpers from "../../store/gallery-helper";

import prod_pol1 from "../../assets/polandArticle/pdfs/Erasmus 2019_prezentacjaPL.pdf";
import prod_pol2 from "../../assets/polandArticle/pdfs/Power_MKozłowska-kopia.pdf";

import prod_cro1 from "../../assets/croatiaArticle/pdfs/Prezentacja Chorwacji_Sanja.pdf";
import prod_cro2 from "../../assets/croatiaArticle/pdfs/Gra poszukiwanie skarbu_Sanja.pdf";
import prod_cro3 from "../../assets/croatiaArticle/pdfs/Gry miejskie_Sanja.pdf";
import prod_cro4 from "../../assets/croatiaArticle/pdfs/Gry na przełamanie lodów_Sanja.pdf";
import prod_cro5 from "../../assets/croatiaArticle/pdfs/Przepisy_Sanja.pdf";
import prod_cro6 from "../../assets/croatiaArticle/pdfs/Słowniczek_Sanja.pdf";

import prod_ger1 from "../../assets/germanyArticle/germany.MOV";
import prod_ger2 from "../../assets/germanyArticle/Zusammengesetzter.mp4";

const MaterialsComponent = (props) => {
  const ctx = useContext(MaterialsContext);
  const [isZoomedIn, setIsZoomedIn] = useState(false);
  const [currentPhoto, setCurrentPhoto] = useState("");

  const content = ctx.photos.map((photo) => (
    <img
      key={photo}
      onClick={() =>
        galleryHelpers.zoomInHandler(photo, setIsZoomedIn, setCurrentPhoto)
      }
      src={photo}
      alt=""
    />
  ));

  return (
    <Fragment>
      <p className="main" id="act"></p>
      <Card>
        <h1>Rezultaty</h1>
        <p className={classes.text}>
          W czasie trwania projektu, uczniowie i nauczyciele ze wszystkich szkół
          realizowali jego założenia w ramach zaplanowanych projektów
          cząstkowych (działania lokalne) oraz podczas spotkań międzynarodowych.
          Stworzono prezentacje małych Ojczyzn, które następnie zostały
          przekazane partnerom i społecznościom lokalnym w formie broszur.
          Przygotowany słowniczek stał się bazą do stworzenia gry miejskiej,
          która była zaplanowana jako efekt finalny projektu. Uczniowie ze
          wszystkich szkół nagrali wspólnie również film „Proud to be European”,
          który był planowanym wspólnym produktem.
        </p>
        <p className={classes.text}>
          Poza tym stworzyliśmy również inne, wcześniej niezaplanowane rezultaty
          naszego projektu. Zaliczają się do nich: konspekty lekcyjne z zakresu
          edukacji wczesnoszkolnej uwzględniające włączanie elementów języka
          angielskiego do nauczania. Powstały również gry: „Poszukiwanie skarbu
          w Zagrzebiu” i „Przełamanie lodów” oraz broszura z przepisami
          kulinarnymi.
        </p>
        <p className={classes.text}>
          Podczas całego projektu przygotowywano w szkołach wystawy
          dokumentujące realizację założeń projektowych, prezentujące
          wypracowane rezultaty i promujące projekt. Rezultaty prezentowano
          również władzom i społecznościom lokalnym podczas europejskich
          pikników rodzinnych.
        </p>
        <h1>Results</h1>
        <p className={classes.text}>
          During the project, students and teachers from all schools implemented
          its assumptions as part of planned sub-projects (local activities) and
          during international meetings. Presentations called „Our little
          Homelands” were created, which were then passed on to partners and
          local communities in the form of brochures. The prepared glossary
          became the basis for creating a city game that was planned as the
          final result of the project. Students from all schools also recorded
          the film "Proud to be European", which was a planned joint product.{" "}
        </p>
        <p className={classes.text}>
          In addition, we also created other, previously unplanned, results of
          our project. They include: lesson plans in the field of early
          childhood education, including the inclusion of elements of the
          English language in teaching. The following games were also created:
          "Treasure Hunt in Zagreb" and "Ice Breaking" and a booklet with
          recipes.
        </p>
        <p className={classes.text}>
          During the entire project, exhibitions documenting the implementation
          of the project assumptions, presenting the achieved results and
          promoting the project were prepared in schools. The results were also
          presented to authorities and local communities at European family
          picnics.
        </p>
        <h1>Pliki do pobrania / Files to download</h1>
        <a className={classes.toDownload} href={filesToDownload} download>
          Kartki świąteczne 2020 / Christmas Cards 2020 <br></br>
          <br></br>
        </a>
        <h1>Produkty do pobrania / Products to download</h1>
        <a className={classes.toDownload} href={prod_pol1} download>
          "Our small homeland" - presentation <br></br>
          <br></br>
        </a>
        <a className={classes.toDownload} href={prod_pol2} download>
          Konspekty zajęć <br></br>
          <br></br>
        </a>
        <a className={classes.toDownload} href={prod_cro1} download>
          Croatia - presentation <br></br>
          <br></br>
        </a>
        <a className={classes.toDownload} href={prod_cro6} download>
          Phrase book <br></br>
          <br></br>
        </a>
        <a className={classes.toDownload} href={prod_cro3} download>
          City Games <br></br>
          <br></br>
        </a>
        <a className={classes.toDownload} href={prod_cro2} download>
          Treasure Hunt <br></br>
          <br></br>
        </a>
        <a className={classes.toDownload} href={prod_cro4} download>
          Ice Breaker Games <br></br>
          <br></br>
        </a>
        <a className={classes.toDownload} href={prod_cro5} download>
          Cooking Recipes <br></br>
          <br></br>
        </a>
        <a className={classes.toDownload} href={prod_ger1} download>
          Lise-Meitner Grammar School - Video <br></br>
          <br></br>
        </a>
        <a className={classes.toDownload} href={prod_ger2} download>
          Proud to be European - Video <br></br>
          <br></br>
        </a>
        <h1 className={classes.header}>Christmas cards</h1>
        <div className={classes.wrapper}>{content}</div>
        {isZoomedIn && (
          <Modal
            onHidePhoto={() => galleryHelpers.zoomOutHandler(setIsZoomedIn)}
            photo={currentPhoto}
          />
        )}
      </Card>
    </Fragment>
  );
};

export default MaterialsComponent;
